module.exports = __webpack_public_path__ + "static/Invoice-System-3-f0660fe4a728e8ae00f383a621a69fd9.svg";